<script setup lang="ts">
import type { VDivider } from 'vuetify/components';
import { computed } from 'vue';

type PropsType = {
    color?: string;
    inset?: boolean;
    length?: string | number;
    opacity?: string | number;
    thickness?: string | number;
    vertical?: boolean;
    classes?: string;
};

const props = withDefaults(defineProps<PropsType>(), {
    color: undefined,
    inset: false,
    length: undefined,
    opacity: undefined,
    thickness: undefined,
    vertical: false,
    classes: '',
});

const getClasses = computed(() => {
    return ' b-divider ' + props.classes;
});

defineOptions({ inheritAttrs: false });
</script>

<template>
    <VDivider
        :color="color"
        :inset="inset"
        :length="length"
        :opacity="opacity"
        :thickness="thickness"
        :vertical="vertical"
        v-bind="$attrs"
        :class="getClasses"
    />
</template>
